import { Record } from 'immutable';

import Hydrator from 'utils/Hydrator';

import { ProductTypeNarrative } from '../enums/product-type';
import ProductResponseTime from './ProductResponseTimeModel';
import LikeliHoodAverage from './LikelihoodAverageModel';
import ProductCost from './ProductCostModel';
import { QuestionnaireType, QuestionnaireTypeByProductType } from '../enums/questionnaire-type';

const InsightProductRecord = Record({
  id: 0,
  productName: '',
  productType: 0,
  cost: null,
  likeliHoodAverage: null,
  responseTime: null,
  providersCount: 0,
  metadata: null,
  description: null,
});

export default class InsightProduct extends InsightProductRecord {
  static deserialize(jsonObject = {}) {
    const mapProperties = {
      responseTime: ProductResponseTime.deserialize,
      likeliHoodAverage: LikeliHoodAverage.deserialize,
      cost: ProductCost.deserialize,
    };

    const hydrated = Object.keys(jsonObject).reduce(Hydrator.assign(jsonObject, mapProperties), {});

    return new InsightProduct(hydrated);
  }

  get description() {
    return ProductTypeNarrative[this.productType];
  }

  get questionnaireType() {
    return (
      QuestionnaireTypeByProductType[this.id] || QuestionnaireType.introducerAllFundingProducts
    );
  }
}
